import { all, fork } from 'redux-saga/effects';
import { notificationsSaga } from '../containers/Notifications/slice/saga';
import { portalSaga } from '../layouts/MainLayout/slice/saga';
import { chatSaga } from '../containers/chat/slice/saga';
import { loginSaga } from '../containers/login/slice/saga';
import { adminSaga } from '../layouts/AdminLayout/slice/saga';
import { adminDashboardSaga } from '../containers/adminDashboard/slice/saga';
import { usersSaga } from '../containers/users/slice/saga';
import { knowledgeBaseSaga } from '../containers/knowledgeBase/slice/saga';

// import templatesSaga from '../features/templates/slice/saga';

// eslint-disable-next-line import/prefer-default-export
export function* rootSaga() {
  yield all([fork(portalSaga)]);
  yield all([fork(notificationsSaga)]);
  yield all([fork(chatSaga)]);
  yield all([fork(loginSaga)]);
  yield all([fork(adminSaga)]);
  yield all([fork(adminDashboardSaga)]);
  yield all([fork(usersSaga)]);
  yield all([fork(knowledgeBaseSaga)]);
}
